export const TRANSPORT_MODES = ['sea', 'air', 'seaAir', 'rail'] as const

export type TransportMode = (typeof TRANSPORT_MODES)[number]
